import { toast } from "react-toastify";
import axiosInstance from "./api";

/**
* Fetch all tournaments with pagination
* @param {number} page - Page number (default: 1)
* @param {number} limit - Number of items per page (default: 20)
* @returns {Promise} Tournament data
*/
export const fetchAllTournaments = async (page = 1, limit = 20) => {
  try {
    const response = await axiosInstance.get(
      `/tournament/all?page=${page}&limit=${limit}`
    );
    if (response?.data?.success) {
      // Return the data object which contains length and data array
      return response.data.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error fetching tournaments:", error);
    toast.error(
      error.response?.data?.message || "Failed to fetch tournaments"
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch tournaments"
    );
  }
};

/**
* Update tournament banner by ID
* @param {string} id - Tournament ID
* @param {FormData} formData - FormData containing the banner image file
* @returns {Promise} Updated tournament data
*/
export const updateTournamentBanner = async (id, formData) => {
  try {
    const response = await axiosInstance.patch(
      `/tournament/banner/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.data?.success) {
      return response.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error updating tournament banner:", error);
    toast.error(
      error.response?.data?.message || "Failed to update tournament banner"
    );
    throw new Error(
      error.response?.data?.message || "Failed to update tournament banner"
    );
  }
};

/**
* Get tournament details by ID
* @param {string} id - Tournament ID
* @returns {Promise} Tournament details
*/
export const getTournamentById = async (id) => {
  try {
    const response = await axiosInstance.get(`/tournament/details/${id}`);
    if (response?.data?.success) {
      return response.data.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error fetching tournament details:", error);
    toast.error(
      error.response?.data?.message || "Failed to fetch tournament details"
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch tournament details"
    );
  }
};